export const DESKTOP_NAV_SECTION_HEIGHTS_PX = {
  expandedHeaderDisplayAd: 260,
  headerDisplayAd: 106,
  mainMenu: 48,
  quoteBar: 52,
  /** @deprecated Use headerDisplayAd */
  raptiveBanner: 106,
  /** @deprecated Use expandedHeaderDisplayAd */
  raptiveExpandedBanner: 260,
  rotatingBanner: 80,
  topBar: 32,
} as const;

export type EstimateDesktopStickyNavOffsetInput = {
  hideTopBar?: boolean;
  hideQuoteBar?: boolean;
  showRotatingBanner?: boolean;
  showHeaderDisplayAd?: boolean;
  expandedHeaderDisplayAd?: boolean;
  /** @deprecated Use showHeaderDisplayAd */
  showRaptiveBanner?: boolean;
  /** @deprecated Use expandedHeaderDisplayAd */
  raptiveExpandedHeader?: boolean;
};

/**
 * SSR-safe desktop nav height for the fixed-header placeholder.
 * Matches composed section heights so first paint does not collapse/expand.
 */
export function estimateDesktopStickyNavOffsetPx({
  expandedHeaderDisplayAd,
  hideQuoteBar,
  hideTopBar,
  raptiveExpandedHeader,
  showHeaderDisplayAd,
  showRaptiveBanner,
  showRotatingBanner,
}: EstimateDesktopStickyNavOffsetInput = {}): number {
  const headerDisplayAdVisible = showHeaderDisplayAd ?? showRaptiveBanner;
  const headerDisplayAdExpanded = expandedHeaderDisplayAd ?? raptiveExpandedHeader;
  let offsetPx = DESKTOP_NAV_SECTION_HEIGHTS_PX.mainMenu;
  if (!hideTopBar) offsetPx += DESKTOP_NAV_SECTION_HEIGHTS_PX.topBar;
  if (!hideQuoteBar) offsetPx += DESKTOP_NAV_SECTION_HEIGHTS_PX.quoteBar;
  if (showRotatingBanner) {
    offsetPx += DESKTOP_NAV_SECTION_HEIGHTS_PX.rotatingBanner;
  } else if (headerDisplayAdVisible) {
    offsetPx += headerDisplayAdExpanded
      ? DESKTOP_NAV_SECTION_HEIGHTS_PX.expandedHeaderDisplayAd
      : DESKTOP_NAV_SECTION_HEIGHTS_PX.headerDisplayAd;
  }
  return offsetPx;
}
